import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import BackButton from '../../../Components/BackButton';
import { FormGroup } from '../../../Components/FormGroup/FormGroup';
import { restPassword } from '../../../Redux/slices/user';
import { useForm } from 'react-hook-form';
import { VscLoading } from 'react-icons/vsc';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import { yupResolver } from '@hookform/resolvers/yup';
// import { firstRestPasswordValidation } from '../../../_helpers/schema-validation';

const Reset = () => {
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [d, uid, token] = window.location.hash.split('/');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur'
    // resolver: yupResolver(firstRestPasswordValidation)
  });

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      let body = {
        new_password: data.confirm_password,
        token: token,
        uid: uid
      };
      // Dispatch password reset
      dispatch(restPassword(body, navigate));
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };
  return (
    <div className="login">
      <div className="login__wrapper d-flex">
        <div className="login__form">
          <img src="/assets/images/logo.webp" alt="logo" className="logo" />
          <div className="title_container my-2">
            <span className="main-title">
              Government of Nepal
              <br />
              <span>Ministry of Federal Affairs and General Administration</span>
              <br />
            </span>

            <span className="text-danger sub-title">
              Provincial and Local Governance Support Program
            </span>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <h4 className="forgotpassword-title">Reset Password</h4>
            <div className="back-button">
              <BackButton />
            </div>
            <Form.Group>
              <FormGroup
                id="new_password"
                label="New Password"
                type="password"
                placeholder="Enter New Password"
                register={register}
                required={true}
                disabled={isLoading}
                error={errors}
              />
            </Form.Group>
            <Form.Group>
              <FormGroup
                id="confirm_password"
                label="Confirm Password"
                type="password"
                placeholder="Enter Confirm Password"
                register={register}
                required={true}
                disabled={isLoading}
                error={errors}
              />
            </Form.Group>
            <Button
              className="btn-primary my-2 d-block btn-round"
              type="submit"
              disabled={isLoading}>
              {isLoading ? <VscLoading className="spin" /> : 'Submit'}
            </Button>
          </Form>

          <div className="copyright">
            <p>Designed and Powered by</p>
            <a href="https://ideabreed.net/" target="_blank" rel="noreferrer">
              Idea Breed IT Solution Pvt. Ltd.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reset;
